var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.912.46a.833.833 0 00-.745-.46H.833a.833.833 0 00-.666 1.333L7.5 11.186v7.147A1.68 1.68 0 009.167 20a1.66 1.66 0 001-.333l1.666-1.25a1.673 1.673 0 00.667-1.334v-5.897l7.333-9.853a.833.833 0 00.079-.873zM4.514 1.833l3.283 4.375a.417.417 0 01.083.25V7.5a.417.417 0 01-.75.25L3.017 2.333a.417.417 0 01.333-.666h.833a.417.417 0 01.331.166z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aeaf6276.svg";
export { ForwardRef as ReactComponent };